import { SVGAssets } from '@business/assets/vectors';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { routePaths } from '@utils/constants/routePaths';
import { useDispatch } from 'react-redux';
import { setFolderDetails } from '@ports/common/folderStateSlice';
import { ContextMenu } from '../../ContextMenu';
import Checkbox from '../../Checkbox/Checkbox';

interface FolderListItemProps {
  folderId: string;
  folderName: string;
  fileCount: number;
  contextMenuItems: Array<{
    id: string;
    label: string | React.ReactNode;
    icon?: React.ReactNode;
    onClick?: () => void;
  }>;
  isSelected?: boolean;
  onSelect?: (folderId: string) => void;
}

export const FolderListItem = ({
  folderId,
  folderName,
  fileCount,
  contextMenuItems,
  isSelected = false,
  onSelect
}: FolderListItemProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Transform context menu items to include onClick wrapper if needed
  const transformedMenuItems = contextMenuItems.map(item => ({
    ...item,
    label:
      typeof item.label === 'string' ? (
        <span className="flex items-center gap-2 text-sm cursor-pointer">
          {item.icon}
          {item.label}
        </span>
      ) : (
        item.label
      )
  }));

  return (
    <div
      className="bg-white rounded-lg border border-gray-200 w-full cursor-pointer"
      onClick={() => {
        dispatch(
          setFolderDetails({ folderName: folderName, folderId: folderId })
        );
        navigate(`${routePaths.Folders}/${folderId}`);
      }}>
      <div className="flex flex-col items-start justify-start py-4 px-4">
        <div className="flex justify-between w-full relative group">
          <Checkbox
            name={`folder-checkbox-${folderName}`}
            checked={isSelected}
            onChange={e => {
              e.stopPropagation();
              onSelect?.(folderId);
            }}
            onClick={e => e.stopPropagation()}
          />
          <div>
            <ContextMenu
              menuItems={transformedMenuItems}
              wrapperClass="!relative !right-0 !top-0"
              itemContainerClass="!absolute !right-0 !top-full !mt-2 !z-[20] !shadow-xl !border !border-gray-200 !py-1 !px-2 !bg-white"
            />
          </div>
        </div>
        <div className="flex items-center justify-center mb-2">
          <SVGAssets.Folder className="w-9 h-9" />
        </div>
        <p className="text-md font-medium text-[#505050]">{folderName}</p>
        <p className="text-xs text-[#8D8D8D]">
          {fileCount}{' '}
          {fileCount === 1 ? t('photosPage.oneFile') : t('photosPage.files')}
        </p>
      </div>
    </div>
  );
};
